'use strict';
import register from './core';
import '../functions/jquery-global.js';



register('researchgroupform-validator', function (element) {
  var $researchgroupform = $('#researchgroup-form');
  var $element = $(element);

   

  $researchgroupform.on('submit', function (event) {
    $("#contactperson-error").hide();
    var contactValid = CheckPersonSearch("#selected-contactperson");
    if (!contactValid) {
      event.preventDefault();
      $("#contactperson-error").show();
      ScrollTo("#contactperson-input-label", 200);
      return;
    }

    $("#faculty-error").hide();
    var facultyValid = CheckFaculty();
    if (!facultyValid) {
      event.preventDefault();
      $("#faculty-error").show();
      ScrollTo("#faculty-list", 200);
      return;
    }

    $("#optin-error").hide();
    var facultyValid = CheckOptin();
    if (!facultyValid) {
      event.preventDefault();
      $("#optin-error").show();
      ScrollTo("#optin-item", 200);
      return;
    }

  });

  function CheckPersonSearch(element) {
    var check = false;

    if ($(element + ' li').length > 0) {
      check = true;
    } 
    return check;
  }

  function CheckFaculty() {   
    var check = false;

    var facultyOptions = $('input[name=Faculties]:checked');
    if (facultyOptions.length > 0) {
      check = true;
    }
    return check;
  }

  function CheckOptin() {
    var check = false;

    var optin = $('input[name="OptinBox"]:checked');
    if (optin.length > 0) {
      check = true;
    }
    return check;
  }

  function ScrollTo(element, time) {
    var timelength = timelength || 1000;
    $('html, body').animate({
      scrollTop: $(element).offset().top - 100
    }, timelength, function () {
    });
  }

  function handleSubmitBtn() {
    let formValid = dateTimeValid;
    $(":submit", $element).prop("disabled", !formValid);
  }


});
